module.exports = __webpack_public_path__ + "img/220.problem_right_elevator.56e74f5e.svg";